export enum Permission {
  ViewChatTraces = 1,
  BetaAccess = 2,
  ApplyFilters = 3,
}